import { MENU_DIRECTIONS } from 'ui/actionMenu/types';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { WarningFill } from 'ui/icons/status/WarningFill';
import { colors } from 'ui/theme/colors';
import { SnippetOverflowMenu } from './SnippetOverflowMenu';
import { SnippetEditorActionButtonsWrapper, UnsavedChangesMessage } from './Styled';
import { GraphQLSnippet } from '../types';
import { useTranslations } from '../hooks/useTranslations';

type Props = {
  hasErrors: boolean;
  handleSaveSnippet: () => void;
  isFooter?: boolean;
  showOverflowMenu: boolean;
  showUnsavedChangesMessage: boolean;
  snippet: GraphQLSnippet;
};

export const SnippetEditorActionButtons = ({
  handleSaveSnippet,
  hasErrors,
  isFooter = false,
  showOverflowMenu,
  showUnsavedChangesMessage,
  snippet,
}: Props) => {
  const { t } = useTranslations();
  return (
    <SnippetEditorActionButtonsWrapper>
      {showUnsavedChangesMessage && (
        <UnsavedChangesMessage data-test="snippet-editor-unsaved-changes-message">
          <WarningFill color={colors.iconWarning} />
          {t('announcement.unsavedChange')}
        </UnsavedChangesMessage>
      )}
      {showOverflowMenu && (
        <SnippetOverflowMenu
          snippet={snippet}
          direction={isFooter ? MENU_DIRECTIONS.TOP : MENU_DIRECTIONS.BOTTOM}
        />
      )}
      <PrimaryButton
        isDisabled={!showUnsavedChangesMessage || hasErrors}
        onClick={() => handleSaveSnippet()}
        size={BUTTON_SIZES.LARGE}
      >
        {t('button.save')}
      </PrimaryButton>
    </SnippetEditorActionButtonsWrapper>
  );
};
